import { TutorialConfig } from "../types/tutorial";

const dashboardTutorial: TutorialConfig = {
  pageId: "dashboard",
  pageTitle: "Dashboard",
  steps: [
    {
      id: "dashboard-kpis",
      title: "Key Performance Indicators",
      description:
        "These cards show your on-time performance, total active orders, and orders at risk or delayed. Click a card to jump to the filtered Orders page.",
      targetSelector: '[data-tutorial-step="dashboard-kpis"]',
      position: "bottom",
    },
    {
      id: "dashboard-map",
      title: "Global Shipment Map",
      description:
        "Visualize where your shipments are moving around the world. Toggle weather and port congestion layers to see risk exposure.",
      targetSelector: '[data-tutorial-step="dashboard-map"]',
      position: "right",
    },
    {
      id: "dashboard-alerts",
      title: "Live Alerts",
      description:
        "Alerts highlight shipments that need immediate attention. Use the View Orders links to drill into affected shipments.",
      targetSelector: '[data-tutorial-step="dashboard-alerts"]',
      position: "left",
    },
  ],
};

export default dashboardTutorial;
